import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';
import { AccessDeniedComponent } from '@core/authentication/components/access-denied/access-denied.component';
import { LoginComponent } from '@core/authentication/components/login/login.component';
import { AuthenticationService } from '@core/authentication/services';
import {
  API_PLATFORM_URL,
  API_URL,
  apiPlatformUrlFactory,
  apiUrlFactory,
} from '@core/config/api-base-url';
import { IEnvironmentVariables } from '@env/IEnvironment';
import { environment } from '@env/environment';
import { ENV } from '@env/environment.token';

export function MSALInstanceFactory(
  environment: IEnvironmentVariables
): IPublicClientApplication {
  var clientApp = new PublicClientApplication({
    ...environment.authConfig.config,
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
  });

  clientApp.initialize();

  return clientApp;
}

export function MSALInterceptorConfigFactory(
  environment: IEnvironmentVariables
): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  environment.authConfig.angularConfig.protectedResourceMap.forEach(
    ([uri, scopes]) => {
      protectedResourceMap.set(uri, scopes);
    }
  );

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(
  environment: IEnvironmentVariables
): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.authConfig.angularConfig.consentScopes,
    },
  };
}

@NgModule({
  imports: [CommonModule, MsalModule],
  providers: [
    {
      provide: ENV,
      useValue: environment,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
      deps: [ENV],
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
      deps: [ENV],
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
      deps: [ENV],
    },
    {
      provide: API_URL,
      useFactory: apiUrlFactory,
      deps: [ENV],
    },
    {
      provide: API_PLATFORM_URL,
      useFactory: apiPlatformUrlFactory,
      deps: [ENV],
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    AuthenticationService,
  ],
})
export class AuthenticationModule {}
